module.exports = __webpack_public_path__ + "img/jimmy.cb620f43.png";